_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[112],{

/***/ "LHH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return /* binding */ __N_SSP; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("4Brf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/seo/FacebookAndTwitterSeoHeaderMeta.jsx
var FacebookAndTwitterSeoHeaderMeta = __webpack_require__("LaX8");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx + 6 modules
var FacetSearch = __webpack_require__("ontP");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/views/search/SearchView.jsx




var __jsx = react_default.a.createElement;














var SearchView_SearchView = function SearchView(_ref) {
  var _config$searchPage, _config$searchPage2, _config$searchPage3, _config$searchPage4, _config$searchPage5;

  var config = _ref.config;
  Object(i18n["a" /* addTranslationKeys */])(config);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var origin = Object(uriUtils["c" /* convertUrlToOrigin */])(appContext.originalUrl);
  var currentUri = origin + router.asPath;
  Object(react["useEffect"])(function () {
    setTimeout(function () {
      return Object(scrollToElement["a" /* scrollToElement */])('.Line-ProductsFilters', 100, '.Navigation-bar');
    }, 2000);
  }, []);
  var isFeatureFlipped = featureFlippingUtils["a" /* isFeatureFlipped */](appContext);
  return __jsx(react["Fragment"], null, __jsx(head_default.a, null, __jsx("title", {
    key: "title"
  }, (config === null || config === void 0 ? void 0 : (_config$searchPage = config.searchPage) === null || _config$searchPage === void 0 ? void 0 : _config$searchPage.title) || ''), __jsx("meta", {
    name: "description",
    content: (config === null || config === void 0 ? void 0 : (_config$searchPage2 = config.searchPage) === null || _config$searchPage2 === void 0 ? void 0 : _config$searchPage2.description) || ''
  })), __jsx(FacebookAndTwitterSeoHeaderMeta["a" /* FacebookAndTwitterSeoHeaderMeta */], {
    description: (config === null || config === void 0 ? void 0 : (_config$searchPage3 = config.searchPage) === null || _config$searchPage3 === void 0 ? void 0 : _config$searchPage3.description) || '',
    immersiveUrl: (config === null || config === void 0 ? void 0 : (_config$searchPage4 = config.searchPage) === null || _config$searchPage4 === void 0 ? void 0 : _config$searchPage4.immersiveImage) || '',
    title: (config === null || config === void 0 ? void 0 : (_config$searchPage5 = config.searchPage) === null || _config$searchPage5 === void 0 ? void 0 : _config$searchPage5.title) || '',
    url: currentUri.toString()
  }), __jsx("main", {
    className: "Line Line-ProductsFilters min-h-[80vh] mt-navigation",
    role: "main"
  }, __jsx(FacetSearch["FacetSearch"], {
    i18n: config,
    isProductComparisonModeAuthorized: isFeatureFlipped('search.productComparison'),
    initialIsSearchEnabled: true,
    fullScreen: true,
    shouldPersistCriteriaInUrl: true,
    shouldSetDefaultDepartureCityOnCompare: true,
    withSearchFacets: true,
    withSearchForm: true,
    withSearchResults: true,
    withWorldMap: isFeatureFlipped('search.worldMap')
  })));
};

SearchView_SearchView.pageId = constants["A" /* SEARCH_PAGE_ID */];
SearchView_SearchView.pageType = tracking_constants["B" /* STATIC_PAGE_TYPES */].SHOPPING_SEARCH;
SearchView_SearchView.disableHeader = sellerUtils["f" /* isSeller */];
SearchView_SearchView.disableFooter = sellerUtils["f" /* isSeller */];
/* harmony default export */ var search_SearchView = (SearchView_SearchView);
// CONCATENATED MODULE: ./pages/s.js

var __N_SSP = true;
/* harmony default export */ var s = __webpack_exports__["default"] = (search_SearchView);

/***/ }),

/***/ "lWeT":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s",
      function () {
        return __webpack_require__("LHH8");
      }
    ]);
  

/***/ })

},[["lWeT",3,1,2,4,0,6,5,9,8,7,10,11,12,13,16,18,25,26,27,30,33,35]]]);